import React from 'react'
import { BlockMain } from '@blocks/BlockMain'
import { MainBlock } from '@blocks/BlockMain/model'
import { scrollToEstateAgentsForm } from '@shared/components/forms/estate-agents'
import PageAnimation from '@shared/components/page-animation'
import { Section } from '@shared/components/section'
import { AppSection } from '@shared/components/sections/app'
import { Rate } from '@shared/components/sections/rate'
import { RiskPoints } from '@shared/components/sections/riskPoints'
import { StepsNoSection } from '@shared/components/sections/steps'
import { ipotekaNerezMainBlock } from 'data/ipotekaNerezMainBlock'

import { FormSection } from './sections/form-section'
import { stepsData } from './sections/steps/data'

import styles from './style.module.scss'

interface Props {
	mainBlockPath?: Partial<MainBlock>
	rateButtonText?: string
	titleGetLoan?: string
	ratePoints?: string[]
	minLoan?: number
	maxLoan?: number
	isAutoLoan?: boolean
}

export const IpotekaNerezScreen = ({
	mainBlockPath,
	ratePoints,
	rateButtonText = 'Получить кредит сейчас',
	titleGetLoan = '3 простых шага для получения кредита',
}: Props) => {
	const data = { ...ipotekaNerezMainBlock, ...mainBlockPath }
	return (
		<PageAnimation>
			<BlockMain
				data={data}
				imageClassname={styles.faceImage}
				buttonProps={{ onClick: scrollToEstateAgentsForm }}
			/>
			<Section className={styles.appWrap} fullWidth>
				<Rate points={ratePoints} buttonText={rateButtonText} />
				{/* <AppSection /> */}
			</Section>
			{/* <Section className={styles.stepsWrap} fullWidth>
				<h2 className={styles.sectionTitle}>{titleGetLoan}</h2>
				<StepsNoSection stepTextStyles={styles.extraTextStyles} steps={stepsData} />
				<h2 className={styles.sectionTitle}>Вы не рискуете</h2>
				<RiskPoints isIpoteka />
			</Section> */}
			<FormSection />
		</PageAnimation>
	)
}
